export default __webpack_public_path__ + "static/media/manual02.65c8ed27.png";